<template>
  <div v-if="order">
    <v-toolbar class="mb-3" elevation="0">
      <v-toolbar-title class="font-weight-medium">{{titlePage}}</v-toolbar-title>
      <v-spacer />
      {{(order.amount) ? $format.money(order.amount): $format.money(order.price)}}
    </v-toolbar>
    <v-container fluid class="pa-0 orderform">
      <v-row>
        <v-col cols="12">
          <v-card elevation="0">
            <v-card-text v-if="order.status=='new' || order.status=='draft'">
              <step v-if="mode == 'editMode'" />
              <confirmation v-if="mode == 'confirmation'" />
              <thanks v-if="mode == 'thanks'" />
            </v-card-text>
            <v-card-text v-if="order.status=='paid' || order.status=='delivered'">
              <order-detail />
              <component :is="include" :order="order" @update="initialize()" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Step from "../../components/services/Step";
import OrderDetail from "../../components/services/OrderDetail";
import Confirmation from "./_confirmation";
import Thanks from "./_thanks";

import BBInclude from "../../components/orders/BBInclude";
import MeeroInclude from "../../components/orders/MeeroInclude";
import FileInclude from "../../components/orders/FileInclude";
import OfferInclude from "../../components/orders/OfferInclude";
import RdvInclude from "../../components/orders/RdvInclude";

import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    Step,
    OrderDetail,
    Confirmation,
    Thanks,
    BBInclude,
    MeeroInclude,
    FileInclude,
    OfferInclude,
    RdvInclude
  },
  data: function() {
    return {
      orderId: null,
      mode: null
    };
  },
  watch: {
    orderMode(mode) {
      this.mode = mode;
    }
  },
  computed: {
    ...mapGetters("orderForm", ["order", "orderMode"]),
    titlePage() {
      if (this.order.status == "new" || this.order.status == "draft") {
        if (this.mode == "editMode") {
          return this.order.service.name;
        } else if (this.mode == "confirmation") {
          return "Confirmer ma commande";
        } else if (this.mode == "thanks") {
          return "Merci pour votre commande";
        }
      } else {
        return (
          "Detail de votre commande pour : '" + this.order.service.name + "'"
        );
      }
      return this.order.service.name;
    },
    include() {
      if (this.order.service.api && this.order.service.api == "bb") {
        return "BBInclude";
      }
      if (this.order.service.api && this.order.service.api == "meero") {
        return "MeeroInclude";
      }
      if (this.order.service.type_id == "rdv") {
        return "RdvInclude";
      }
      if (this.order.service.type_id == "file") {
        return "FileInclude";
      }
      if (this.order.service.type_id == "offer") {
        return "OfferInclude";
      }
      return "";
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    ...mapActions("orderForm", ["clean", "submit"]),
    initialize() {
      if (this.$route.params.id) {
        this.orderId = parseInt(this.$route.params.id);
        this.getOrder();
      } else {
        this.$router.push("/orders");
      }
    },
    getOrder() {
      this.$store.dispatch("order/get", this.orderId).then(() => {
        let order = this.$store.getters["order/order"];
        this.$store.dispatch("orderForm/load", order);
      });
    }
  },
  beforeDestroy() {
    this.clean();
  }
};
</script>

<style lang="less">
.orderForm {
}
</style>